<template>
    <div v-if="visible" class="drawer-header">
        <div>
            <Button
                v-if="onBack"
                class="drawer-back"
                icon="Arrow"
                size="m"
                color="transparent"
                :onClick="onBack" />

            <div class="drawer-title">
                <Element v-if="title" element="h2" :font="titleFont" class="title">
                    {{ title }}
                </Element>
                <Element v-if="subTitle" element="h3" :font="subTitleFont" class="subtitle">
                    {{ subTitle }}
                </Element>
            </div>
        </div>

        <ButtonIcon
            v-if="onClose"
            :onClick="onClose"
            icon="Cross"
            :ariaLabel="t({ key: 'shared.close' })"
            size="m" />
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType, computed } from 'vue';
    import Button from '@ui/components/Button/Button.vue';
    import Element from '@ui/components/Element/Element.vue';
    import ButtonIcon from '@ui/components/Button/ButtonIcon.vue';
    import { Font } from '@ui/components/Element/Element.interfaces';

    export default defineComponent({
        name: 'Header',
        components: { Button, ButtonIcon, Element },
        methods: { t },
        props: {
            onBack: Function,
            onClose: Function,
            title: String,
            titleFont: {
                type: String as PropType<Font>,
                default: 'font-body-l',
            },
            subTitle: { type: String as PropType<string | null> },
            subTitleFont: {
                type: String as PropType<Font>,
                default: 'font-body-m',
            },
        },
        setup(props) {
            const visible = computed<boolean>(() => {
                return Boolean(
                    props.onBack || props.onClose || props.title || props.subTitle
                );
            });

            return { visible };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Header.scss';
</style>
